// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"76":"common","153":"analytics","231":"content-translate","352":"onboarding","472":"settings","541":"string-translate","543":"translations","585":"migration","928":"languages"}[chunkId] + ".chunk.js";
};